export const environment = {
  //baseURL:process.env.REACT_APP_BASE_URL || "https://corphousing-dev.keenminds.in/v1",
  //baseURL: process.env.REACT_APP_BASE_URL || "http://localhost:5225",
    baseURL: process.env.REACT_APP_BASE_URL || 'https://corp-api.iosrelobridge.com',
  apiKey: process.env.REACT_APP_API_KEY || "fallback-dev-api-key",
};

